import {
    Country,
    Gender,
    PhoneWithAreaCode,
    Prefix,
    Telephone,
} from "./address-form.constants";

export const ACCOUNT_PATH = "/account/";
export const ORDER_HISTORY_PATH = "/account/orders/";
export const LOGIN_PATH = "/login/";

export const ADDRESS = "address";
export type Address = typeof ADDRESS;
export const CPF_NUMBER = "cpfNumber";
export type CpfNumber = typeof CPF_NUMBER;
export const DATE_OF_BIRTH = "dateOfBirth";
export type DateOfBirth = typeof DATE_OF_BIRTH;
export const EMAIL = "email";
export type Email = typeof EMAIL;
export const FIRSTNAME = "firstname";
export type Firstname = typeof FIRSTNAME;
export const FIRSTNAME2 = "firstname2";
export type Firstname2 = typeof FIRSTNAME2;
export const LASTNAME = "lastname";
export type Lastname = typeof LASTNAME;
export const LASTNAME2 = "lastname2";
export type Lastname2 = typeof LASTNAME2;
export const LOGINPHONE = "loginphone";
export type Loginphone = typeof LOGINPHONE;
export const MIDDLENAME = "middlename";
export type Middlename = typeof MIDDLENAME;
export const NEWSLETTER = "newsletter";
export type Newsletter = typeof NEWSLETTER;
export const PASSWORD = "password";
export type Password = typeof PASSWORD;
export const PHONECODE = "phonecode";
export type Phonecode = typeof PHONECODE;
export const SOCIAL_SECURITY_NUMBER = "socialSecurityNumber";
export type SocialSecurityNumber = typeof SOCIAL_SECURITY_NUMBER;
export const VERIFICATION_CODE = "verificationCode";
export type VerificationCode = typeof VERIFICATION_CODE;
export const PIPL = "pipl";
export type Pipl = typeof PIPL;
export const COMMUNICATION_CONSENT = "communicationConsent";
export type CommunicationConsent = typeof COMMUNICATION_CONSENT;
export const KOREAN_PROMOTIONAL_OPTIN = "koreanPromotionalOptIn";
export type KoreanPromotionalOptin = typeof KOREAN_PROMOTIONAL_OPTIN;
export const EMAIL_SEND_CODE = "emailSendCode";
export type EmailSendCode = typeof EMAIL_SEND_CODE;
export const DATA_POLICY = "dataPolicy";
export const TERMS_OF_USE = "termsOfUse";

export type LoginInfoFields =
    | Email
    | Password
    | PhoneWithAreaCode
    | Phonecode
    | Loginphone
    | VerificationCode
    | EmailSendCode;

export type PersonalInfoFields =
    | CpfNumber
    | Country
    | DateOfBirth
    | Firstname
    | Firstname2
    | Gender
    | Lastname
    | Lastname2
    | Loginphone
    | Middlename
    | Phonecode
    | Prefix
    | SocialSecurityNumber
    | Telephone
    | VerificationCode;

export type LegalInfoFields =
    | Pipl
    | CommunicationConsent
    | KoreanPromotionalOptin;
export const OLD_PASSWORD_INVALID = "old_password_invalid";
export const UPDATE_PASSWORD_GONE_WRONG = "update_password_gone_wrong";
export const UPDATE_PASSWORD_SUCCESS = "update_password_success";

export type UpdatePasswordErrorsResponseType =
    | typeof OLD_PASSWORD_INVALID
    | typeof UPDATE_PASSWORD_GONE_WRONG
    | typeof UPDATE_PASSWORD_SUCCESS;
export interface UpdatePasswordResponse {
    event: UpdatePasswordErrorsResponseType;
}
